import {Card, CardActions, TableCell} from "@material-ui/core";
import React from "react";

import { makeStyles } from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import Typography from "@material-ui/core/Typography";
import BBIconExeExecuteCircle from "../../../assets/bbCustomIcons/BBIconExeExecuteCircle";
import BBIconSatelliteDish from "../../../assets/bbCustomIcons/BBIconSatelliteDish";
import BBIconEvadeAvoid from "../../../assets/bbCustomIcons/BBIconEvadeAvoid";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import Link from "@material-ui/core/Link";
import Skeleton from "react-loading-skeleton";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        textAlign: "center",
        padding: '6px 16px',
    },
    leafHeading : {
        textAlign: "left"
    },
    secondaryTail: {
        backgroundColor: theme.palette.secondary.main,
    },
    footNote: {
        marginLeft: "auto",
        marginRight: theme.spacing(2),
        // float: "right",
        fontSize: "smaller",
        color: 'gray'
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    expandIcon: {
        fontSize: 16,
    },
    footer: {

        // borderTop: "solid 2px gray",
        // borderBottom: "solid 9px gray",
        padding: 0,
    },
    collapse: {

    },
}));

const GhostTimeline = () => {
    const classes = useStyles();

    return (
        <>

        <Timeline align="alternate">
            <h3 className={"text-center"}><em>Loading Attack Timeline...</em></h3>
                    {/*<TimelineItem >*/}
                    {/*    <TimelineOppositeContent/>*/}
                    {/*    <TimelineSeparator>*/}

                    {/*        <TimelineConnector/>*/}

                    {/*    </TimelineSeparator>*/}
                    {/*    <TimelineContent/>*/}
                    {/*</TimelineItem>*/}

                    <TimelineItem >
                        <TimelineOppositeContent>
                            <Typography variant="h6" color="textSecondary">
                                <Tooltip title={`An example.`}>
                                    <span>
                                        <Skeleton />
                                    </span>
                                </Tooltip>
                            </Typography>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineDot>
                                <Tooltip title={`An example.`}>
                                    <span>
                                        <BBIconSatelliteDish/>
                                    </span>
                                </Tooltip>
                            </TimelineDot>

                                <TimelineConnector/>

                        </TimelineSeparator>
                        <TimelineContent className= {"mb-5"}>
                            <Card className={classes.root } elevation={3}>
                                <Typography variant="h5" className={classes.leafHeading}>
                                    <Skeleton />
                                    <div className={"float-right mx-1"}>
                                        <Tooltip title={``}>
                                            <span>
                                                <Skeleton />
                                            </span>
                                        </Tooltip>
                                    </div>
                                </Typography>
                                <div className={"px-5 mx-5 my-2"} style={{fontSize: "medium"}}>
                                    <Skeleton />
                                </div>

                                {/*<Typography variant="h6" >MITRE ATT&CK Info</Typography>*/}
                                <Table size="small" >
                                    <TableBody>
                                        <TableRow >
                                            <TableCell >
                                                <Skeleton style={{width:"100px"}}/>
                                            </TableCell>
                                            <TableCell >
                                                <Tooltip title={``}>
                                                    <Link href={null} target="_blank" rel="noopener">
                                                        <Skeleton style={{width:"200px"}}/>
                                                    </Link>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow >
                                            <TableCell >
                                                <Skeleton style={{width:"100px"}}/>
                                            </TableCell>
                                            <TableCell >
                                                <Skeleton count={3} style={{width:"200px"}}/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow >
                                            <TableCell >
                                                <Skeleton style={{width:"100px"}}/>
                                            </TableCell>
                                            <TableCell >
                                                <Skeleton count={2} style={{width:"200px"}}/>
                                            </TableCell>
                                        </TableRow>

                                    </TableBody>
                                </Table>
                                <br/>
                                    <CardActions disableSpacing  className={classes.footer} type={"button"}>
                                        <Typography className={classes.footNote} >

                                        </Typography>
                                        <Typography className={classes.centerFootNote} > </Typography>
                                        <Typography className={classes.footNote} > <Skeleton/></Typography>


                                        <IconButton
                                            className={clsx(classes.expand)}
                                        >
                                            <ExpandMoreIcon className={classes.expandIcon} />
                                        </IconButton>
                                    </CardActions>
                            </Card>
                        </TimelineContent>
                    </TimelineItem>
            <TimelineItem >
                <TimelineOppositeContent>
                    <Typography variant="h6" color="textSecondary">
                        <Tooltip title={`An example.`}>
                                    <span>
                                        <Skeleton />
                                    </span>
                        </Tooltip>
                    </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot>
                        <Tooltip title={`An example.`}>
                                    <span>
                                        <BBIconExeExecuteCircle/>
                                    </span>
                        </Tooltip>
                    </TimelineDot>

                    <TimelineConnector/>

                </TimelineSeparator>
                <TimelineContent>
                    <Card className={classes.root } elevation={3}>
                        <Typography variant="h5" className={classes.leafHeading}>
                            <Skeleton />
                            <div className={"float-right mx-1"}>
                                <Tooltip title={``}>
                                            <span>
                                                <Skeleton />
                                            </span>
                                </Tooltip>
                            </div>
                        </Typography>
                        <div className={"px-5 mx-5 my-2"} style={{fontSize: "medium"}}>
                            <Skeleton />
                        </div>

                        {/*<Typography variant="h6" >MITRE ATT&CK Info</Typography>*/}
                        <Table size="small" >
                            <TableBody>
                                <TableRow >
                                    <TableCell >
                                        <Skeleton style={{width:"100px"}}/>
                                    </TableCell>
                                    <TableCell >
                                        <Tooltip title={``}>
                                            <Link href={null} target="_blank" rel="noopener">
                                                <Skeleton style={{width:"200px"}}/>
                                            </Link>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                                <TableRow >
                                    <TableCell >
                                        <Skeleton style={{width:"100px"}}/>
                                    </TableCell>
                                    <TableCell >
                                        <Skeleton count={3} style={{width:"200px"}}/>
                                    </TableCell>
                                </TableRow>
                                <TableRow >
                                    <TableCell >
                                        <Skeleton style={{width:"100px"}}/>
                                    </TableCell>
                                    <TableCell >
                                        <Skeleton count={2} style={{width:"200px"}}/>
                                    </TableCell>
                                </TableRow>

                            </TableBody>
                        </Table>
                        <br/>
                        <CardActions disableSpacing  className={classes.footer} type={"button"}>
                            <Typography className={classes.footNote} >

                            </Typography>
                            <Typography className={classes.centerFootNote} > </Typography>
                            <Typography className={classes.footNote} > <Skeleton/></Typography>


                            <IconButton
                                className={clsx(classes.expand)}
                            >
                                <ExpandMoreIcon className={classes.expandIcon} />
                            </IconButton>
                        </CardActions>
                    </Card>
                </TimelineContent>
            </TimelineItem>
            <TimelineItem >
                <TimelineOppositeContent>
                    <Typography variant="h6" color="textSecondary">
                        <Tooltip title={`An example.`}>
                                    <span>
                                        <Skeleton />
                                    </span>
                        </Tooltip>
                    </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot>
                        <Tooltip title={`An example.`}>
                                    <span>
                                        <BBIconEvadeAvoid/>
                                    </span>
                        </Tooltip>
                    </TimelineDot>

                    <TimelineConnector/>

                </TimelineSeparator>
                <TimelineContent>
                    <Card className={classes.root } elevation={3}>
                        <Typography variant="h5" className={classes.leafHeading}>
                            <Skeleton />
                            <div className={"float-right mx-1"}>
                                <Tooltip title={``}>
                                            <span>
                                                <Skeleton />
                                            </span>
                                </Tooltip>
                            </div>
                        </Typography>
                        <div className={"px-5 mx-5 my-2"} style={{fontSize: "medium"}}>
                            <Skeleton />
                        </div>

                        {/*<Typography variant="h6" >MITRE ATT&CK Info</Typography>*/}
                        <Table size="small" >
                            <TableBody>
                                <TableRow >
                                    <TableCell >
                                        <Skeleton style={{width:"100px"}}/>
                                    </TableCell>
                                    <TableCell >
                                        <Tooltip title={``}>
                                            <Link href={null} target="_blank" rel="noopener">
                                                <Skeleton style={{width:"200px"}}/>
                                            </Link>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                                <TableRow >
                                    <TableCell >
                                        <Skeleton style={{width:"100px"}}/>
                                    </TableCell>
                                    <TableCell >
                                        <Skeleton count={3} style={{width:"200px"}}/>
                                    </TableCell>
                                </TableRow>
                                <TableRow >
                                    <TableCell >
                                        <Skeleton style={{width:"100px"}}/>
                                    </TableCell>
                                    <TableCell >
                                        <Skeleton count={2} style={{width:"200px"}}/>
                                    </TableCell>
                                </TableRow>

                            </TableBody>
                        </Table>
                        <br/>
                        <CardActions disableSpacing  className={classes.footer} type={"button"}>
                            <Typography className={classes.footNote} >

                            </Typography>
                            <Typography className={classes.centerFootNote} > </Typography>
                            <Typography className={classes.footNote} > <Skeleton/></Typography>


                            <IconButton
                                className={clsx(classes.expand)}
                            >
                                <ExpandMoreIcon className={classes.expandIcon} />
                            </IconButton>
                        </CardActions>
                    </Card>
                </TimelineContent>
            </TimelineItem>

        </Timeline>
        </>
    );
};

GhostTimeline.propTypes = {
};



export default GhostTimeline;